export const pluralize = (size: number) => (size !== 1 ? "s" : "")
